import { addDays, isAfter } from 'date-fns';
//
import featureConstants from '../../constants/featureConstants';
// uncomment this line if business decide to exclude apple products from clearpay
// import brandConstants from '../../constants/brandConstants';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';

export default function isBasketClearpayEligible(state) {

  if (!isFeatureActive(state, featureConstants.ENABLE_CLEARPAY)) return false;

  const items = state.orderForm?.items || [];

  // uncomment these lines and those in .spec.rtl.js if business decide to exclude apple products from clearpay
  //
  // const basketContainsAppleProducts = items.some(item => item.brand === brandConstants.APPLE);
  // if (basketContainsAppleProducts) return false;

  const basketContainsAlcohol = items.some(item => item.productType === 'Alcohol');
  if (basketContainsAlcohol) return false;

  if (state.orderForm.amounts.outstandingBalanceRaw < 30 || state.orderForm.amounts.outstandingBalanceRaw > 1000) {
    return false;
  }

  if (!state.orderForm.isClickCollectOrder) {
    const deliveryDates = state.orderForm.deliveries?.map(delivery => delivery.fulfilment.deliveryInfo.date);
    const fourteenDaysFromNow = addDays(new Date(), 14);

    const deliveriesTooLate = deliveryDates?.some(date => isAfter(date, fourteenDaysFromNow));
    if (deliveriesTooLate) return false;
  }

  return true;
}
